module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "fin-prueba-bor aligner",
    attrs: {
      "xs6": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('image-app', {
    staticClass: "animated bounceIn",
    attrs: {
      "imaSize": 200,
      "imaSrc": 'logos-icons/bullet-ok-roja',
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeInRight",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md8": "",
      "pa-5": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": _vm.titleAccess,
      "titleLevel": "h2"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._t("partOne")], 2), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._t("partTwo")], 2), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._t("partThree")], 2)], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e00f058","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actividades/act-pantallafinal.vue
// module id = 963
// module chunks = 1